
import { createElement } from "react";
import React from "react";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { SidebarTextButton } from "../Components/Button.js";
import { map, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";

const scrollOptions = new (class {
    get behavior() {
        return "smooth";
    }
    set behavior(_arg) {
    }
    get block() {
        return "center";
    }
    set block(_arg_1) {
    }
    get inline() {
        return "center";
    }
    set inline(_arg_2) {
    }
}
)();

export function scrollToSection(targetId) {
    document.getElementById(targetId).scrollIntoView(scrollOptions);
}

export function selectAndScroll(setSelectedAnchor, targetId) {
    scrollToSection(targetId);
    setSelectedAnchor(targetId);
}

function AreaAnchor(props) {
    let elems, Variant;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mb-2"])], (elems = [createElement(SidebarTextButton, (Variant = (props.Selected ? "blueButton" : "default"), {
        ComponentState: "enabled",
        Label: props.Label,
        OnClick: () => {
            props.OnClick();
            scrollToSection(props.Id);
        },
        TestId: concat("area-anchor-button-", ...props.Id),
        Variant: Variant,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function AreaAnchorMenu(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["sticky", "top-5"])], (elems = toList(delay(() => map((anchor) => createElement(AreaAnchor, {
        Id: anchor.Id,
        Label: anchor.Label,
        OnClick: () => {
            props.OnSelectAnchor(anchor.Id);
        },
        Selected: props.SelectedAnchor === anchor.Id,
    }), props.Anchors))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

